import React, { useEffect, useState ,useRef} from "react";
import { connect, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Flatpickr from "react-flatpickr";
import moment from "moment";
import { Link } from "react-router-dom";
import * as appConstants from "../../constants/ApplicationConstants";
import "../../../node_modules/flatpickr/dist/themes/material_blue.css";
import {
  getDefaultFilters,
  getImpersonatedUserId,
  getPayerSoldToForInvoiceQuery,
  getSelectedPrimaryAccount,
  getSelectedSecondaryAccount,
} from "../../selectors/Selectors";
import {
  adjustCurrency,
  getInvoicesAjax,
  setsearchedInvoices,
  setsearchedinvoiceStatus,
  setsearchedInvoiceNumber,
  setsearchedinvoiceDueDate,
  setsearchedinvoiceType,
  setsearchedArticleNumber,
  setsearchedArticleDescription,
  getPaymentInvoicesAjax,
  setinvoiceSearchedPeriodFromTo,
} from "../../actions/InvoiceActions";
import { InvoiceSearchList } from "./InvoiceList";
//import {
//  DocumentStatus,
//  DocumentType,
//  InvoiceRequestBody,
//} from "../../interfaces/invoice";
import { FormattedMessage, useIntl } from "react-intl";
import { useCalendarTranslation } from "../../hooks/CalendarTranslation";
import { SecondarySelect } from "../SecondarySelect";
import { AccountType } from "../../interfaces/Accounts";
import { RootState } from "../../reducers/RootReducer";
import { useCurrencyDecimalLookup } from "../../selectors/ConfigSelectors";
import { useDispatch } from "react-redux";
import { CurrencySelector, useHasMultiCurrency } from "./CurrencySelector";
import { BootstrapField } from "../../helpers/Field";
import { PregnantWomanOutlined } from "@material-ui/icons";
import { SoldToCellConnected } from "./SoldToCell";
import "../../../node_modules/flatpickr/dist/themes/material_blue.css";
import BootstrapTable from 'react-bootstrap-table-next';
import { FormatDateOptions } from 'react-intl';
import { DropdownButton, Dropdown } from "react-bootstrap";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import _ from "lodash";
import { useMediaQuery } from "react-responsive";
import { ReactComponent as SortUpIcon } from "../../images/sort-icons/sort-up.svg";
import { ReactComponent as SortDownIcon } from "../../images/sort-icons/sort-down.svg";
import { ReactComponent as SortNoneIcon } from "../../images/sort-icons/sort-none.svg";
import {
    csvMoneyFormatter,
    dateFormatter,
    paymentCardType,
    referenceFormatter, paidFormatter, removeLeadingZeros, billDocumentFormatter
} from "../../common/invoiceHelpers";
import {
    DocumentStatus,
    DocumentType,
    InvoiceRequestBody, PaymentWithKey, PaymentInvoice
} from "../../interfaces/invoice";
import ExportExcelPayment from "./ExportExcelPayment";
import { getInvoiceKey, isStringNotEmptyOrNull } from "../../utils";

import { error } from "console";
let paymentWithKeys: PaymentWithKey[] = [];
let AvailableCurrencies: string[] = [];
let DDLSelectedCurrency = "";
let originalInvoices = [];


interface InvoiceSearchState {
  invoices: any[];
  searched: boolean;
  status: DocumentStatus;
  dueDateFrom: string;
  dueDateTo: string;
  period: string;
  dateFrom: string;
  dateTo: string;
  characteristics: string;
  characteristicsValue: string;
  characteristicsLabel: string;
  showDatesDue: boolean;
  showPeriod: boolean;
  showDatesPeriod: boolean;
  showCharacteristicsValue: boolean;
  allAccounts:any;
}

function _PaymentHistory(props) {
    //props.searchInvoices = null;
  const [sdInvoices, setSdInvoices] = useState<PaymentWithKey[]>([]);
  const [paymentList, setPaymentList] = useState<PaymentInvoice[]>([]);
  const hasMultiCurrency = useHasMultiCurrency();
  //const selectedCurrency = useSelector<RootState, string>(
  //  (state) => state.default.selectedCurrencyOptionValue
  //);
  const intl = useIntl();
  const f = (id) => intl.formatMessage({ id: id });
  const calIl8n = useCalendarTranslation();
  const [toDate, setToDate] = useState(moment(new Date()).format("MM-DD-YYYY"));
  const [fromDate, setFromDate] = useState(
    moment(new Date()).format("MM-DD-YYYY")
    );

 const [selectedCurrency, setSelectedCurrency] = useState("");
 const [companyCodes, setCompanyCodes] = useState<any[]>([]);
  const accountType = useSelector<RootState, AccountType>(
    (store) => store?.user_options?.accountType
  );
  const decimalLookup = useCurrencyDecimalLookup();
  const dispatch = useDispatch();
  let [state, setState] = useState({
    invoices: [],
    searched: false,
    status: DocumentStatus.OpenOrComplete,
    dueDateFrom: "",
    dueDateTo: "",
    period: "all",
    dateFrom: "",
    dateTo: "",
    invoiceNumber:"",
    characteristics: "",
    characteristicsValue: "",
    characteristicsLabel: "",
    showDatesDue: false,
    showPeriod: true,
    showDatesPeriod: false,
    showCharacteristicsValue: false,
    materialNumber: "",
    materialDescription: "",
    documentType: "",
    SoldToSearchParams: props.selectedSoldTo,
  });

  useEffect(() => {
    setState({
      ...state,
      invoices: [],
      searched: false,
      status: DocumentStatus.OpenOrComplete,
      dueDateFrom: "",
      dueDateTo: "",
      period: "all",
      dateFrom: "",
      dateTo: "",
      invoiceNumber:"",
      characteristics: "",
      characteristicsValue: "",
      characteristicsLabel: "",
      showDatesDue: false,
      showPeriod: true,
      showDatesPeriod: false,
      showCharacteristicsValue: false,
      materialNumber: "",
      materialDescription: "",
      documentType: "",
      SoldToSearchParams: props.selectedSoldTo,
    });
  }, [
    props.primaryAccountIndex,
    props.selectedSecondaryAccount,
    props.selectedCurrency,
  ]);

  //alert(props.selectedSoldTo);

  useEffect(() => {
    let searched = props.searchInvoices ? true : false;
    let invoices = [];
    let materialDescription = props.searchedArticleDescription;
    let SoldToSearchParams = props.selectedSoldTo;
    let materialNumber = props.searchedArticleNumber;
    let characteristicsValue = props.searchedInvoiceNumber;
    let status = props.searchedinvoiceStatus
      ? props.searchedinvoiceStatus
      : DocumentStatus.OpenOrComplete;
    let showDatesDue =
      props.searchedinvoiceStatus && props.searchedinvoiceStatus === "01"
        ? true
        : false;
    let showPeriod =
      props.searchedinvoiceStatus && props.searchedinvoiceStatus !== "01"
        ? true
        : false;
    let documentType = props.searchedinvoiceType;
    let period = props.invoiceSearchedPeriod;
    let showDatesPeriod =
      props.invoiceSearchedPeriod && props.invoiceSearchedPeriod === "-1";
    let dueDateFrom =
      props.searchedinvoiceDueDateFrom !== ""
        ? props.searchedinvoiceDueDateFrom
        : "";
    let dueDateTo =
      props.searchedinvoiceDueDateTo !== ""
        ? props.searchedinvoiceDueDateTo
        : "";
    let dateFrom =
      props.invoiceSearchedPeriodFrom !== ""
        ? props.invoiceSearchedPeriodFrom
        : "";
    let dateTo =
      props.invoiceSearchedPeriodTo !== "" ? props.invoiceSearchedPeriodTo : "";
    if (
      props.searchedinvoiceStatus === "01" &&
      props.searchedinvoiceDueDateFrom !== "" &&
      props.searchedinvoiceDueDateTo !== ""
    ) {
      setFromDate(props.searchedinvoiceDueDateFrom);
      setToDate(props.searchedinvoiceDueDateTo);
    }
    if (
      props.invoiceSearchedPeriod === "-1" &&
      props.invoiceSearchedPeriodFrom !== "" &&
      props.invoiceSearchedPeriodTo !== ""
    ) {
      setFromDate(props.invoiceSearchedPeriodFrom);
      setToDate(props.invoiceSearchedPeriodTo);
    }

    if (props.searchedinvoiceStatus === "01") {
      status = DocumentStatus.OpenOrComplete;
    }
    let currency = props.selectedCurrencyOptionValue;
    //let selectedSoldTo: props.user_options.selectedSoldTos,
    //let SoldToSearchParams=
    setState({
      ...state,
      searched: searched,
      invoices: invoices,
      materialDescription: materialDescription,
      materialNumber: materialNumber,
      invoiceNumber: "",
      characteristicsValue: "",
      status: status,
      showDatesDue: showDatesDue,
      showPeriod: showPeriod,
      documentType: documentType,
      period: period,
      showDatesPeriod: showDatesPeriod,
      dueDateFrom: dueDateFrom,
      dueDateTo: dueDateTo,
      dateFrom: dateFrom,
      dateTo: dateTo,
      SoldToSearchParams: props.SoldToSearchParams,
      //currency:currency,
    });
  }, []);

  let handleDueFromChange = (date) => {
    let fromDue = date;
    if (fromDue && fromDue.length > 0) {
      fromDue = moment(fromDue[0]).format("MM-DD-YYYY");
    } else {
      fromDue = moment([new Date().getFullYear(), 11, 31]).format("MM-DD-YYYY");
    }

    setFromDate(fromDue);

    // setState({
    //     ...state,
    //     dueDateFrom: fromDue,

    // });

    setState((prevState) => ({
      ...prevState,
      dueDateFrom: fromDue,
    }));
    dispatch(setsearchedinvoiceDueDate(fromDue, toDate));
  };

  let handleDueToChange = (date) => {
    let toDue = date;
    if (toDue && toDue.length > 0) {
      toDue = moment(toDue[0]).format("MM-DD-YYYY");
    } else {
      toDue = moment([new Date().getFullYear(), 11, 31]).format("MM-DD-YYYY");
    }

    setToDate(toDue);
    // setState({
    //     ...state,
    //     dueDateTo: toDue,

    // });
    setState((prevState) => ({
      ...prevState,
      dueDateTo: toDue,
    }));
    dispatch(setsearchedinvoiceDueDate(fromDate, toDue));
  };

  //let handlePeriodFromChange = (date) => {
  //  let fromPeriod = date;
  //  if (fromPeriod && fromPeriod.length > 0) {
  //    fromPeriod = moment(fromPeriod[0]).format("MM-DD-YYYY");
  //  } else {
  //    fromPeriod = moment([new Date().getFullYear(), 11, 31]).format(
  //      "MM-DD-YYYY"
  //    );
  //  }

  //  setFromDate(fromPeriod);

  //  // setState({
  //  //     ...state,
  //  //     dateFrom: fromPeriod,

  //  // });

  //  setState((prevState) => ({
  //    ...prevState,
  //    dateFrom: fromPeriod,
  //  }));

  //  dispatch(setinvoiceSearchedPeriodFromTo(fromPeriod, toDate));
  //};

  //let handlePeriodToChange = (date) => {
  //  let toPeriod = date;
  //  if (toPeriod && toPeriod.length > 0) {
  //    toPeriod = moment(toPeriod[0]).format("MM-DD-YYYY");
  //  } else {
  //    toPeriod = moment([new Date().getFullYear(), 11, 31]).format(
  //      "MM-DD-YYYY"
  //    );
  //  }

  //  setToDate(toPeriod);
  //  // setState({
  //  //     ...state,
  //  //     dateTo: toPeriod,
  //  // });

  //  setState((prevState) => ({
  //    ...prevState,
  //    dateTo: toPeriod,
  //  }));

  //  dispatch(setinvoiceSearchedPeriodFromTo(fromDate, toPeriod));
  //};

  function onDateChange(selectedDates, dateStr, instance) {
    if (selectedDates && selectedDates.length > 0) {
      setToDate(selectedDates[0]);
    }
    if (selectedDates && selectedDates.length > 1) {
      setFromDate(selectedDates[1]);
    }

    let from = "";
    let to = "";
    if (selectedDates && selectedDates.length > 0) {
      from =
        selectedDates[0] && selectedDates[1]
          ? moment(selectedDates[0]).format("MM-DD-YYYY")
          : "";
      to =
        selectedDates[0] && selectedDates[1]
          ? moment(selectedDates[1]).format("MM-DD-YYYY")
          : "";
    }
    const controlId = instance.input.id;
    switch (controlId) {
      case "datesDue":
        // setState({
        //     ...state,
        //     dueDateFrom: from,
        //     dueDateTo: to
        // });

        setState((prevState) => ({
          ...prevState,
          dueDateFrom: from,
          dueDateTo: to,
        }));

        dispatch(setsearchedinvoiceDueDate(selectedDates[0], selectedDates[1]));

        break;
      case "datesPeriod":
        // setState({
        //     ...state,
        //     dateFrom: from, dateTo: to
        // });

        setState((prevState) => ({
          ...prevState,
          dateFrom: from,
          dateTo: to,
        }));
        dispatch(
          setinvoiceSearchedPeriodFromTo(selectedDates[0], selectedDates[1])
        );
        break;
      default:
        break;
    }
  }

  //function onSelectChange(name) {
  //  return function (e) {
  //    let option = e.target.value;
  //    switch (name) {
  //      case "status":
  //        // setState({
  //        //     ...state,
  //        //     status: option,
  //        //     showDatesDue: option && option === '01',
  //        //     showPeriod: option && option !== '01',
  //        //     period: 'all',
  //        //     showDatesPeriod: false,
  //        // });

  //        setState((prevState) => ({
  //          ...prevState,
  //          status: option,
  //          showDatesDue: option && option === "01",
  //          showPeriod: option && option !== "01",
  //          period: "all",
  //          showDatesPeriod: false,
  //        }));
  //        setFromDate(moment(new Date()).format("MM-DD-YYYY"));

  //        setToDate(moment(new Date()).format("MM-DD-YYYY"));
  //        dispatch(setsearchedinvoiceDueDate("", ""));
  //        dispatch(setinvoiceSearchedPeriodFromTo("", ""));
  //        dispatch(setsearchedinvoiceStatus(option));
  //        dispatch(setinvoiceSearchedPeriod("all"));
  //        break;
  //      case "period":
  //        setState((prevState) => ({
  //          ...prevState,
  //          period: option,
  //          showDatesPeriod: option && option === "-1",
  //        }));

  //        setFromDate("");
  //        setToDate("");
  //        dispatch(setsearchedinvoiceDueDate("", ""));
  //        dispatch(setinvoiceSearchedPeriodFromTo("", ""));
  //        dispatch(setinvoiceSearchedPeriod(option));
  //        break;
  //      case "characteristics":
  //        // setState({
  //        //     ...state,
  //        //     characteristics: option ? option : '',
  //        //     showCharacteristicsValue: option && option,
  //        //     characteristicsLabel: option ? e.target.options[e.target.selectedIndex].text : '',
  //        // });

  //        setState((prevState) => ({
  //          ...prevState,
  //          characteristics: option ? option : "",
  //          showCharacteristicsValue: option && option,
  //          characteristicsLabel: option
  //            ? e.target.options[e.target.selectedIndex].text
  //            : "",
  //        }));

  //        break;
  //      default:
  //        break;
  //    }
  //  };
  //}

  //function onCharacteristicsValueChange(e) {
  //  // setState({
  //  //     ...state,
  //  //     characteristicsValue: e.target.value
  //  // });
  //  setState((prevState) => ({
  //    ...prevState,
  //    characteristicsValue: e.target.value,
  //  }));

  //  dispatch(setsearchedInvoiceNumber(e.target.value));
  //}

  function onMaterialDescriptionChange(e) {
    // setState({
    //     ...state,
    //     materialDescription: e.target.value
    // });
    setState((prevState) => ({
      ...prevState,
      materialDescription: e.target.value,
    }));
    dispatch(setsearchedArticleDescription(e.target.value));
    }

  


  function onMaterialNumberChange(e) {
    // setState({
    //     ...state,
    //     materialNumber: e.target.value
    // });

    setState((prevState) => ({
      ...prevState,
      materialNumber: e.target.value,
    }));

    dispatch(setsearchedArticleNumber(e.target.value));
  }

  function onDocumentTypeChange(e) {
    // setState({
    //     ...state,
    //     documentType: e.target.value
    // });

    setState((prevState) => ({
      ...prevState,
      documentType: e.target.value,
    }));

    dispatch(setsearchedinvoiceType(e.target.value));
  }

 

  function exportToPdf() {
    try {
      let search = getSearch();
      props.getInvoiceSearchPDF(search);
    } catch (e) {
      return null;
    }
  }

    useEffect(()=>{
        setSdInvoices([]);
        setPaymentList([]);
        const codeArray= Object.values(props.allAccounts);
        const allCompanyCodes=codeArray.filter((item:any)=>item.PrimaryAcct===props.primaryAccount.PrimaryAcct);
        const codes=allCompanyCodes.map((item:any)=>item.CompanyCode);
        setCompanyCodes(codes);
  
    },[props.primaryAccount.PrimaryAcct]);

    function getSearch(validate: boolean = false): InvoiceRequestBody | null {
        let { dateFrom, dateTo } = state;
        const { period, invoiceNumber } = state;


        if (period === "all") {
            dateFrom = "01-01-1800";
            dateTo = "12-31-9999";
        } else if (period === "-1") {
            dateFrom = moment(dateFrom).format("MM-DD-YYYY");
            dateTo = moment(dateTo).format("MM-DD-YYYY");
        } else if (period === "0") {
            //Today
            dateFrom = moment(new Date()).format("MM-DD-YYYY");
            dateTo = moment(new Date()).format("MM-DD-YYYY");
        } else if (period === "1") {
            //Since yesterday
            const today = new Date();
            const yesterday = new Date();
            yesterday.setDate(today.getDate() - 1);
            dateFrom = moment(yesterday).format("MM-DD-YYYY");
            dateTo = moment(today).format("MM-DD-YYYY");
        } else if (period === "7") {
            //Since last week
            const today = new Date();
            const lastSevenDays = new Date();
            lastSevenDays.setDate(today.getDate() - 7);
            dateFrom = moment(lastSevenDays).format("MM-DD-YYYY");
            dateTo = moment(today).format("MM-DD-YYYY");
        } else if (period === "30") {
            //Since last 30 days
            const today = new Date();
            const lastThirtyDays = new Date();
            lastThirtyDays.setDate(today.getDate() - 30);
            dateFrom = moment(lastThirtyDays).format("MM-DD-YYYY");
            dateTo = moment(today).format("MM-DD-YYYY");
        } else if (period === "365") {
            //Since last 30 days
            const today = new Date();
            const lastOneYear = new Date();
            lastOneYear.setDate(today.getDate() - 365);
            dateFrom = moment(lastOneYear).format("MM-DD-YYYY");
            dateTo = moment(today).format("MM-DD-YYYY");
        } else {
            dateFrom = "";
            dateTo = "";
        }
        const filters: { filter_type: string; value: string }[] = [];
        if (isStringNotEmptyOrNull(invoiceNumber)) {
            filters.push({ filter_type: "01", value: invoiceNumber });
        }

        //if (state.documentType == "payment") {
        //    filters.push({ filter_type: "92", value: "x" });
        //}
        //if (state.documentType == "credit") {
        //  filters.push({ filter_type: "93", value: "X" });
        //}

        let { payer_data, soldto_data } = getPayerSoldToForInvoiceQuery(
            props.accountType,
            props.secondaryAccount,
            props.primaryAccount
        );

        const allCompanyCodes = normalizeCompanyCodes(companyCodes);
        const primaryCompanyCode = payer_data.company_code;
        const additionalCodes = allCompanyCodes.filter((c) => c && c !== primaryCompanyCode);
        const companyCodeFilters = additionalCodes.map((code) => ({
          filter_type: "96",
          value: String(code),
          })
        );

        return {
            payer_data,
            soldto_data,
            search_parameters: {
                //  billing_document_number:
                document_type: DocumentType.Payment,//02
                status: DocumentStatus.Open,//01
                date_from: dateFrom,
                date_to: dateTo,
                due_date_from: "",
                due_date_to: "",
                currency_key: "",
                SoldTo_SearchParams: props.selectedSoldTo,
                filter: getDefaultFilters(
                    props.accountType,
                    props.impersonatedUserId
                ).concat(filters as any).concat(companyCodeFilters as any),
            },
        };
    }

      const normalizeCompanyCodes = (cc: string[] | string[][] | undefined | null): string[] => {
        if (!cc) return [];
          return Array.isArray((cc as any)[0]) ? (cc as string[][])[0] ?? [] : (cc as string[]);
      };

    function renderCaret(order, column) {
        if (order === "desc") {
            return <SortUpIcon className={"d-inline-block table-header-sort-icon"} />;
        }
        if (order === "asc") {
            return <SortDownIcon className={"d-inline-block table-header-sort-icon"} />;
        }
        return <SortNoneIcon className={"d-inline-block table-header-sort-icon"} />;
    }

    function mapSoldTo(cell) {
        // return <SoldToCellConnected value={cell} />;
        if (cell) {
            if (isNaN(cell)) {
                return <span className="main-table-cell">{cell}</span>;
            } else {
                return (
                    <span className="main-table-cell">{removeLeadingZeros(cell)}</span>
                );
            }
        }
        return "";
    }

    function onFindClick() {
        let { dateFrom, dateTo } = state;
        const { period, status } = state;

        try {
            if (
                period === "-1" &&
                (dateFrom === "" ||
                    dateFrom === null ||
                    dateTo === "" ||
                    dateTo === null)
            ) {
                toast.error(f("invoice_search.error.document_dates_required"), {
                    position: toast.POSITION.TOP_RIGHT,
                });
                return;
            }

            if (props.accoutType === "Payer" && props.selectedSoldTo.length === 0) {
                toast.error(f("invoice_search.error.select_customer"), {
                    position: toast.POSITION.TOP_RIGHT,
                });
                return;
            }

            let search = getSearch(true);

            if (search) {
                getPaymentInvoicesAjax(search).then((response) => {
                    if (response && response.data && response.data.document_list) {
                        const invoices = response.data.document_list as any[];

                        let extractedSdInvoices: PaymentWithKey[] = [];

                        invoices.forEach((invoice) => {
                            if (invoice.sd_invoices && invoice.sd_invoices.length > 0) {
                                extractedSdInvoices.push(...invoice.sd_invoices.map((subInvoice: any) => ({
                                    ...subInvoice,
                                    _key: getInvoiceKey(subInvoice),
                                    document_number_finance: invoice.document_number_finance, // Add document_number_finance from invoice
                                    payment_card_token: invoice.payment_card_token,
                                    payment_card_type: invoice.payment_card_type,
                                    document_date: invoice?.document_date,
                                    soldto_number: subInvoice?.soldto_number || invoice?.payer_number
                                })));
                            }
                        });

                        // Dispatch action with sd_invoices
                      //  dispatch(setSearchePaymentInvoices(extractedSdInvoices));

                        // Set state with sd_invoices
                        setSdInvoices(extractedSdInvoices);
                        setPaymentList(extractedSdInvoices);
                    } else {
                        console.error("Error: Response data is undefined or null.");
                    }
                }).catch(error => {
                    console.error("Error occurred while fetching payment invoices:", error);
                });
            }
        } catch (error) {
            console.error("An error occurred:", error);
        }
    }


    const handleCurrencySelect = (e: string) => {
        if (e === "All") {

            setPaymentList(originalInvoices);
            paymentWithKeys = originalInvoices.map((_: PaymentWithKey) => {
                _._key = getInvoiceKey(_);
                return _ as PaymentWithKey;
            });
            DDLSelectedCurrency = "";
        }
        else {

            DDLSelectedCurrency = e;

            const newList = originalInvoices
                .filter((item: PaymentWithKey) => item.currency_key === e)

            if (newList.length > 0) {
                setPaymentList(newList);
                paymentWithKeys = newList.map((_: PaymentWithKey) => {
                    _._key = getInvoiceKey(_);
                    return _ as PaymentWithKey;
                });

            } else {

            }
        }
    };
useEffect(() => {
  if (sdInvoices && sdInvoices.length > 0) {
    LoadCurrencies(sdInvoices);
  }
  else {
    // clear everything if no invoices
    AvailableCurrencies.length = 0;
    DDLSelectedCurrency = "";
    setSelectedCurrency("");
    paymentWithKeys = [];
  }
}, [sdInvoices]);

    const LoadCurrencies = (invoices) => {
        AvailableCurrencies.length = 0;
        invoices.forEach((invoice) => {
            if (AvailableCurrencies.indexOf(invoice.currency_key) === -1) {
                AvailableCurrencies.push(invoice.currency_key);
            }
        });
        if (AvailableCurrencies.length === 1) {
            DDLSelectedCurrency = AvailableCurrencies[0].toString();
        }
        if (AvailableCurrencies.length > 0) {
            let value;

            if (AvailableCurrencies.includes("USD")) {
                value = "USD";
                paymentWithKeys = invoices.filter(
                    (item) => item.currency_key === value
                );
                setSelectedCurrency(value);


            }
            else {
                value = AvailableCurrencies[0].toString();
                paymentWithKeys = invoices.filter(
                    (item) => item.currency_key === value
                );
                setSelectedCurrency(value);

            }
        }
    };

    const handlePeriodFromChange = (date) => {
        let fromPeriod = date;
        if (fromPeriod && fromPeriod.length > 0) {
            fromPeriod = moment(fromPeriod[0]).format("MM-DD-YYYY");
        } else {
            fromPeriod = moment([new Date().getFullYear(), 11, 31]).format("MM-DD-YYYY");
        }
        setFromDate(fromPeriod);

        setState((prevState) => ({
            ...prevState,
            dateFrom: fromPeriod,
        }));

        //dispatch(setPaymentSearchedPeriodFromTo(fromPeriod, toDate || ""));
    };

    let handlePeriodToChange = (date) => {
        let toPeriod = date!;
        if (toPeriod.length > 0) {
            toPeriod = moment(toPeriod[0]).format("MM-DD-YYYY");
        } else {
            toPeriod = moment([new Date().getFullYear(), 11, 31]).format("MM-DD-YYYY");
        }

        setToDate(toPeriod);
        setState((prevState) => ({
            ...prevState,
            dateTo: toPeriod || "",
        }));

       // dispatch(setPaymentSearchedPeriodFromTo(fromDate, toPeriod || ""));
    };


    function onSelectChange(name) {
        return function (e) {
            let option = e.target.value;
            switch (name) {
                case "status":
                    setState((prevState) => ({
                        ...prevState,
                        status: option,

                        showPeriod: option && option !== "01",
                        period: "30",
                        showDatesPeriod: false,
                    }));
                    setFromDate(moment(new Date()).format("MM-DD-YYYY"));

                    setToDate(moment(new Date()).format("MM-DD-YYYY"));

                   // dispatch(setPaymentSearchedPeriodFromTo("", ""));
                   // dispatch(setsearchedpaymentStatus(option));
                   // dispatch(setPaymentSearchedPeriod("all"));
                    break;
                case "period":
                    setState((prevState) => ({
                        ...prevState,
                        period: option,
                        showDatesPeriod: option && option === "-1",
                    }));

                    setFromDate("");
                    setToDate("");

                   // dispatch(setPaymentSearchedPeriodFromTo("", ""));
                   // dispatch(setPaymentSearchedPeriod(option));
                    break;
                case "characteristics":


                    setState((prevState) => ({
                        ...prevState,
                        invoiceNumber: option ? option : "",
                        showCharacteristicsValue: option && option,
                        characteristicsLabel: option
                            ? e.target.options[e.target.selectedIndex].text
                            : "",
                    }));

                    break;
                default:
                    break;
            }
        };
    }

    function onCharacteristicsValueChange(e) {

        setState((prevState) => ({
            ...prevState,
             invoiceNumber: e.target.value,
        }));

         dispatch(setsearchedInvoiceNumber(e.target.value));
    }
  function getDateFrom(days) {
    const date = new Date();
    date.setDate(date.getDate() - days);
    return moment(date).format("MM-DD-YYYY");
    }

const extractLast4 = (token: string): string => {
  if (!token) return "";
  const match = token.match(/-(\d{4})-/);
  return match ? match[1] : "";
};

const paymentMethodText = (row: any) => {
  const type = row?.payment_card_type || "";
  const token = String(row?.payment_card_token || "");
  const last4 = extractLast4(token);
  return last4 ? `${type} *${last4}` : type;
};

    const columns = [
        {
            headerClasses: "payment-detail-column-header",
            dataField: "document_number_finance",
            formatter: referenceFormatter,
            text: f("payment_history.doc_number"),
            sort: true,
            sortCaret: renderCaret,
            headerStyle: { width: '65px' },
            headerAlign: "center",
            align: "center",
        },
        {
            headerClasses: "payment-detail-column-header",
            dataField: "reference_number",
            formatter: referenceFormatter,
            text: f("payment_history.reference_number"),
            sort: true,
            sortCaret: renderCaret,
            headerStyle: { width: '55px' },
            headerAlign: "center",
            align: "center"
        },
        {
            headerClasses: "payment-detail-column-header",
            dataField: "billing_document_number",
            formatter: billDocumentFormatter,
            text: f("payment_history.invoice_number"),
            headerStyle: { width: '55px' },
            headerAlign: "center",
            align: "center"
        },
        {
            headerClasses: "payment-detail-column-header payment-column-multi-line display-linebreak",
            dataField: "document_date",
            formatter: dateFormatter,
            text: f("payment_history.date"),
            sort: true,
            sortCaret: renderCaret,
            headerStyle: { width: '55px' },
            headerAlign: "center",
            align: "center"
        },
        {
            headerClasses: "payment-detail-column-header payment-column-multi-line display-linebreak",
            dataField: "paid_amount",
            formatter: paidFormatter,
            sort: true,
            sortCaret: renderCaret,
            csvMoneyFormatter: csvMoneyFormatter(intl),
            text: f("payment_history.amount"),
            headerStyle: { width: '55px' },
            headerAlign: "center",
            align: "center"
        },

        {
            headerClasses: "payment-detail-column-header payment-column-multi-line display-linebreak",
            dataField: "payment_card_token",
            sort: true,
            sortCaret: renderCaret,
            csvFormatter: (_cell, row) => paymentMethodText(row),
            formatter: paymentCardType,
            text: f("payment_history.payment_method"),
            headerStyle: { width: '55px' },
            headerAlign: "center",
            align: "center"
        },


        {
            headerClasses: "payment-detail-column-header",
            dataField: "soldto_number",

            formatter: mapSoldTo,
            text: f("payment_history.account"),
            headerStyle: { width: '55px' },
            headerAlign: "center",
            align: "center"
        },

    ];

    const d = (dateString: string, options?: FormatDateOptions) => intl.formatDate(dateString, options);
    const top = 'Top';
    const tab = useRef('table');


  const countOfInvoices = state.invoices ? state.invoices.length : 0;
  return (
    <div className="container invoicePage">
      <div className="row" style={{ marginLeft: "15px" }}>
        <div className="col-lg-11 col-md-11 col-sm-11 col-11">
          <h2 className="invoicesHeading bottompadding">
             <FormattedMessage id={"payment_search.page_title"} />
          </h2>
        </div>
      </div>
      <div
        className="card"
        style={{
          paddingTop: "60px",
          marginLeft: "30px",
          marginRight: "30px",
          marginBottom: "30px",
        }}
      >
        <div className="card-body nopadding">
          <div className="row">
            <div className="col-lg-2 col-md-4 col-sm-4 col-4 bottompadding">
              <span className="float-right col-form-label col-form-label-sm text-secondary">
                <FormattedMessage id={"deposits.Account_label"} />
              </span>
            </div>
            <div className="col-lg-4 col-md-8 col-sm-8 col-8 bottompadding customSelect">
              <SecondarySelect accountType={accountType} />
            </div>
                  </div>

          <div className="row">
            <div
              className={`${"col-lg-2 col-md-4 col-sm-4 col-4 float-right bottompadding"}${" "}${
                state.showPeriod ? "" : "hideControl"
              }`}
            >
              <span className="float-right col-form-label col-form-label-sm text-secondary">
                <FormattedMessage id={"invoice_search.period_label"} />
              </span>
            </div>
            <div
              className={`${"col-lg-4 col-md-8 col-sm-8 col-8 bottompadding customSelect"}${" "}${
                state.showPeriod ? "" : "hideControl"
              }`}
            >
              <select
                name="period"
                className="form-control"
                value={state.period}
                onChange={onSelectChange("period")}
              >
                <option value={"all"} selected={state.period === "all"}>
                  {intl.formatMessage({
                    id: "invoice_search.status_filter.all",
                    defaultMessage: "All",
                  })}
                </option>
                <option value={"0"} selected={state.period === "0"}>
                  {f("invoice_search.date_filter.today")}
                </option>
                <option value={"1"} selected={state.period === "1"}>
                  {f("invoice_search.date_filter.yesterday")}
                </option>
                <option value={"7"} selected={state.period === "7"}>
                  {f("invoice_search.date_filter.last_7_days")}
                </option>
                <option value={"30"} selected={state.period === "30"}>
                  {f("invoice_search.date_filter.last_30_days")}
                </option>
                <option value={"365"} selected={state.period === "365"}>
                  {f("invoice_search.date_filter.last_year")}
                </option>
                <option value={"-1"} selected={state.period === "-1"}>
                  {f("invoice_search.date_filter.custom")}
                </option>
              </select>
              <i className="fas fa-chevron-down select-arrow" />
            </div>
            <div
              className={`${"col-lg-4 col-md-8 col-sm-8 col-8 bottompadding"}${" "}${
                state.showPeriod && state.showDatesPeriod ? "" : "hideControl"
              }`}
            >
              <div className="col datetimepickerdiv">
                <div className="form-check-inline-date-first">
                  <div>
                    <i className="calendarPosition fa fa-calendar-alt" />
                    <Flatpickr
                      className="inp form-control inv-calendar"
                      options={{
                        formatDate: (date) => {
                          return intl.formatDate(date);
                        },
                        locale: calIl8n,
                      }}
                      onClose={handlePeriodFromChange}
                      placeholder="From"
                    />
                  </div>
                </div>

                <div className="form-check-inline-date">
                  <div>
                    <i className="calendarPosition fa fa-calendar-alt" />
                    <Flatpickr
                      className="inp form-control inv-calendar"
                      options={{
                        formatDate: (date) => {
                          return intl.formatDate(date);
                        },
                        locale: calIl8n,
                      }}
                      onClose={handlePeriodToChange}
                      placeholder="To"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-2 col-md-4 col-sm-4 col-4 bottompadding">
              <span className="float-right col-form-label col-form-label-sm text-secondary">
                <FormattedMessage
                  id={"invoice_search.search_options.invoice_number"}
                />
              </span>
            </div>
            <div className={"col-lg-4 col-md-8 col-sm-8 col-8 bottompadding"}>
              <input
                type="text"
                className="form-control control-border"
                placeholder={f("invoice_search.search_options.invoice_number")}
                value={state.invoiceNumber}
                name="invoiceNumber"
                onChange={onCharacteristicsValueChange}
              />
            </div>
          </div>
        

          <div className="form-row text-center mt-4">
            <div className="col-12">
              <button
                type="button"
                className="btn btn-primary findButtonColor form-control control-border button-class"
                onClick={onFindClick}
              >
                <FormattedMessage id={"invoice_search.find_button"} />
              </button>
            </div>
          </div>

          <br />
        </div>
      </div>

      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12 col-12">
          <span className="invoiceSearch col-form-label col-form-label-sm text-secondary float-right">
            {props.searched && (
              <span>
                {countOfInvoices} {f("invoices.found")}
              </span>
            )}
          </span>
        </div>
      </div>
      {/*<div className="row">*/}
      {/*  <div className="col">*/}
      {/*    <InvoiceSearchList*/}
      {/*      invoices={state.invoices}*/}
      {/*      isSearch={true}*/}
      {/*      invoiceSearchQuery={getSearch()}*/}
      {/*    />*/}
      {/*  </div>*/}
          {/*</div>*/}

          <div className="row">

              <div className="col">

                  <React.Fragment>
                      <ToolkitProvider
                          data={paymentList}
                          ref={tab}
                          headerStyle={{
                              background: "#DFECF5",
                              height: "40px",
                              borderCollapse: "collapse",
                          }}
                          classes={"wa-bootstrap-table-container custom-table-header"}
                          scrollTop={top}
                          columns={columns}
                          keyField={"_key"}
                          bootstrap4={true}
                          exportCSV={{
                              noAutoBOM: { autoBom: true },
                          }}
                      >
                          {(toolkitProps) => (
                              <>
                                  <div className="row py-2">
                                      {/*<div className="col-12 col-md d-flex align-items-end order-2 order-md-0 ">*/}
                                      <div className="col-12 col-md d-flex align-items-end order-2 order-md-0 ">
                                      </div>
                                      {hasMultiCurrency && DDLSelectedCurrency === "" && selectedCurrency !== "" && (
                                          <div className={"col-12 col-md d-flex justify-content-center  align-items-baseline"}>
                                              <span className={"invoice-currency-warning"} style={{ fontSize: "0.84rem", alignSelf: "center" }}>
                                                  <FormattedMessage id={"invoices_page.currency_warning"} values={{ currency: selectedCurrency }} />
                                              </span>
                                          </div>
                                      )}

                                      {paymentWithKeys.length > 0 && DDLSelectedCurrency !== "" && (
                                          <div className={"col-12 col-md d-flex justify-content-center  align-items-baseline"}>                                                    <span className={"invoice-currency-warning"} style={{ fontSize: "0.84rem", alignSelf: "center" }}>
                                              <FormattedMessage id={"invoices_page.currency_warning"} values={{ currency: DDLSelectedCurrency }} />
                                          </span>
                                          </div>
                                      )}
                                      {/*</div>*/}

                                      <div
                                          className={
                                              "col d-flex justify-content-end  align-items-baseline order-1 order-md-0"
                                          }
                                      >


                                          {
                                              <DropdownButton
                                                  alignRight
                                                  size={"sm"}
                                                  title={intl.formatMessage({
                                                      id: "invoice_export.all_currency",
                                                  })}
                                                  variant={"light"}
                                                  id="dropdown-menu-currency"
                                                  onSelect={(e) => {
                                                      if (e) {
                                                          handleCurrencySelect(e);
                                                      }
                                                  }}
                                              >

                                                  {/*{ (*/}
                                                  {/*    <Dropdown.Item eventKey="All">*/}
                                                  {/*        {f("invoice_search.status_filter.all")}*/}
                                                  {/*    </Dropdown.Item>*/}
                                                  {/*)}*/}

                                                  {AvailableCurrencies.map((currency) => (

                                                      <Dropdown.Item eventKey={currency}>
                                                          {currency}
                                                      </Dropdown.Item>
                                                  ))}
                                              </DropdownButton>
                                          }
                                          {paymentList.length === 0 ? (
                                              <DropdownButton
                                                  disabled={true}
                                                  alignRight
                                                  size={"sm"}
                                                  title={intl.formatMessage({
                                                      id: "invoice_export.export_label",
                                                  })}
                                                  variant={"light"}
                                                  id="dropdown-menu-align-right"
                                              >
                                                  <Dropdown.Item
                                                      onClick={(e) => {
                                                          e.preventDefault();
                                                          toolkitProps.csvProps.onExport();
                                                      }}
                                                  >
                                                      {intl.formatMessage({ id: "invoice_export.all_csv" })}
                                                  </Dropdown.Item>

                                              </DropdownButton>
                                          ) : (
                                              <DropdownButton
                                                  alignRight
                                                  size={"sm"}
                                                  title={intl.formatMessage({
                                                      id: "invoice_export.export_label",
                                                  })}
                                                  variant={"light"}
                                                  id="dropdown-menu-align-right"
                                              >
                                                  <Dropdown.Item
                                                      onClick={(e) => {
                                                          e.preventDefault();
                                                          toolkitProps.csvProps.onExport();
                                                      }}
                                                  >
                                                      {intl.formatMessage({ id: "invoice_export.all_csv" })}
                                                  </Dropdown.Item>
                                                  {props.isSearch ? (
                                                      <ExportExcelPayment
                                                          data={{
                                                              invoicesData: paymentWithKeys,
                                                              columnsData: columns,
                                                          }}
                                                          className="dropdown-item !important"
                                                      />
                                                  ) : (
                                                      <ExportExcelPayment
                                                          data={{
                                                              invoicesData: paymentWithKeys,
                                                              columnsData: columns,
                                                          }}
                                                          className="dropdown-item !important"
                                                      />
                                                  )}
                                              </DropdownButton>
                                          )}
                                      </div>
                                  </div>

                                  {
                                      <div className="row">

                                          <div className="col-12">
                                              <BootstrapTable
                                                  {...toolkitProps.baseProps}
                                                  keyField={'_key'}
                                                  data={paymentList}
                                                  defaultSorted={[{ dataField: "document_date", order: "desc" }]}
                                                  noDataIndication={() => f("invoice_not_found")}
                                                  classes={
                                                      "wa-bootstrap-table-container custom-table-header"
                                                  }
                                              ></BootstrapTable>
                                          </div>

                                      </div>
                                  }
                              </>
                          )}
                      </ToolkitProvider>
                  </React.Fragment>


              </div>

          </div>
      <br />
      <br />
      <br />
      <br />
    </div>
  );
}

export default connect<any, any, any, any>(
  (store, props) => ({
    accountType: store.user_options.accountType,
    primaryAccount: getSelectedPrimaryAccount(store),
    primaryAccountIndex: store.user_options.selectedPrimaryAccountIndex, //getSelectedPrimaryAccountIndex(store, props),
    secondaryAccount: getSelectedSecondaryAccount(store),
    characteristicsOptions: store.default.characteristicsOptions,
    filter: store.user_options.filter,
    impersonatedUserId: getImpersonatedUserId(store),
    searchInvoices: store.invoice.searchInvoices,
    searchedinvoiceStatus: store.invoice.searchedinvoiceStatus,
    searchedinvoiceDueDateFrom: store.invoice.searchedinvoiceDueDateFrom,
    searchedinvoiceDueDateTo: store.invoice.searchedinvoiceDueDateTo,
    searchedinvoiceType: store.invoice.searchedinvoiceType,
    searchedInvoiceNumber: store.invoice.searchedInvoiceNumber,
    searchedArticleNumber: store.invoice.searchedArticleNumber,
    searchedArticleDescription: store.invoice.searchedArticleDescription,
    invoiceSearchedPeriod: store.invoice.invoiceSearchedPeriod,
    invoiceSearchedPeriodFrom: store.invoice.invoiceSearchedPeriodFrom,
    invoiceSearchedPeriodTo: store.invoice.invoiceSearchedPeriodTo,
    selectedSecondaryAccount: store.user_options.selectedSecondaryAccount,
    selectedSoldTo: store.user_options.selectedSoldTos,
    accoutType: store.user_options.accountType,
    allAccounts: store.user_options.allAccounts,
  }),
  {},
  null,
  { pure: false }
)(_PaymentHistory);
